import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Google = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.0007 8.15546C15.0007 7.57991 14.953 7.15991 14.8499 6.72437H8.14355V9.32211H12.08C12.0007 9.96769 11.5721 10.9399 10.6197 11.5932L10.6064 11.6802L12.7268 13.29L12.8737 13.3044C14.2229 12.0832 15.0007 10.2866 15.0007 8.15546Z"
          fill="#4285F4"
        />
        <path
          d="M8.14315 15C10.0717 15 11.6907 14.3777 12.8733 13.3044L10.6193 11.5933C10.0162 12.0055 9.20662 12.2933 8.14315 12.2933C6.25428 12.2933 4.65113 11.0722 4.07965 9.38438L3.99588 9.39136L1.79104 11.0636L1.76221 11.1422C2.93679 13.4288 5.34949 15 8.14315 15Z"
          fill="#34A853"
        />
        <path
          d="M4.08006 9.38443C3.92927 8.94888 3.84201 8.48218 3.84201 7.99998C3.84201 7.51773 3.92927 7.05108 4.07213 6.61553L4.06814 6.52277L1.83566 4.82368L1.76262 4.85773C1.27851 5.80663 1.00073 6.87221 1.00073 7.99998C1.00073 9.12776 1.27851 10.1933 1.76262 11.1422L4.08006 9.38443Z"
          fill="#FBBC05"
        />
        <path
          d="M8.14319 3.70665C9.48444 3.70665 10.3892 4.27442 10.9051 4.7489L12.9209 2.82C11.6829 1.69223 10.0717 1 8.14319 1C5.34951 1 2.9368 2.5711 1.76221 4.85775L4.07173 6.61555C4.65114 4.92777 6.25431 3.70665 8.14319 3.70665Z"
          fill="#EB4335"
        />
      </svg>
    </svg>
  )
})

export default Google
